import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Input, Space, Table, Typography, Select } from "antd";
import { LeftOutlined, BulbOutlined, PlusOutlined } from "@ant-design/icons";

const { Search } = Input;

const Roles = () => {
  const [pageSize, setPageSize] = useState(10);
  const navigate = useNavigate();

  const columns = [
    { title: "Name", dataIndex: "Name", key: "Name" },
    { title: "Employees", dataIndex: "Employees", key: "Employees" },
  ];

  const data = [
    {
      key: 1,
      Name: "Administrator",
      Employees: 1,
    },
  ];

  return (
    <div className="p-4 bg-white rounded-lg shadow flex flex-col gap-5">
      <div className="flex justify-between items-center">
        <h4 className="!mb-0 font-semibold">Manage Roles</h4>
        <Space>
          <Button
            icon={<LeftOutlined />}
            type="default"
            onClick={() => navigate(-1)}
          >
            Back
          </Button>
          <Button icon={<BulbOutlined />}>Page Tip</Button>
        </Space>
      </div>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <Typography.Text className="whitespace-nowrap">
            Showing 1 - {data.length}
          </Typography.Text>
          <Search placeholder="Search" allowClear className="w-full max-w-sm" />
          <Button
            type="primary"
            icon={<PlusOutlined />}
            className="bg-primary text-white"
          >
            Create New
          </Button>
        </div>

        <div className="flex  items-center gap-2">
          <Typography.Text>Show</Typography.Text>
          <Select
            defaultValue={10}
            onChange={(value) => setPageSize(value)}
            options={[10, 20, 30].map((size) => ({ value: size, label: size }))}
          />
          <Typography.Text>Entries</Typography.Text>
        </div>
      </div>
      <Table
        columns={columns}
        dataSource={data}
        scroll={{ x: 'max-content' }}
          pagination={{
          pageSize: pageSize,
          showSizeChanger: true,
          onShowSizeChange: (_, size) => setPageSize(size),
        }}
        className="bg-white rounded-lg border border-gray-200"
      />
    </div>
  );
};

export default Roles;
